<template>
  <div class="confirm">
    <Flow v-bind:step="5"/>
    <div class="bg_white mt12 pt16 pb16 boxs1 pl15 pr15">
      <h1 class="complete_text ab">注文が完了しました。</h1>

      <div v-if="errorList.length != 0" class="mt12">
        <p class="error_text ab">{{ message }}</p>
        <p class="errorBc_text ab">失敗したBC</p>
        <ul class="errorBc_list">
          <li class="errorBc_list--item ab" v-for="val in errorList">BC{{ val.bcNo + ': ' + val.errorMessage }}</li>
        </ul>
      </div>
      <router-link :to="{ name: 'selectBC' }" v-on:click.native="strageClear(true)" class="complete_btn btn btn_blue">BC選択に戻る</router-link>
    </div>
    <ConfirmProductsList :edit="false" />

    <div class="bg_white mt12 pt16 pb16 boxs1">
      <h2 class="content_title rb">配達日指定</h2>
      <div class="confirm_wrap pl16 pr25 bdb">
        <p class="confirm_data rb">{{ userData.deliveryDate ? userData.deliveryDate : '指定配達日なし' }}</p>
      </div>
    </div>
    <div class="bg_white mt12 pt16 pb16 boxs1">
      <h2 class="content_title rb">配送時間指定</h2>
      <div class="confirm_wrap pl16 pr25 bdb">
        <p class="confirm_data rb">{{ this.userData.shippingTime }}</p>
      </div>
    </div>
    <div class="confirm_address bg_white mt12 pt16 pb16 boxs1">
      <h2 class="content_title rb">配送住所</h2>
      <div class="confirm_wrap pl16 pr25 bdb">
        <div class="">
          <p class="confirm_data rb">{{ this.userData.shippingName }}</p>
          <p class="data_contents">〒{{ this.userData.shippingZip }} {{ this.userData.shippingAddress }}</p>
        </div>
      </div>
    </div>
    <div class="confirm_credit bg_white mt12 pt16 pb16 boxs1">
      <h2 class="content_title rb">お支払い情報</h2>
      <div class="confirm_wrap pl16 pr25 bdb">
        <div class="">
          <p class="confirm_data rb">{{ this.userData.paymethod }}</p>
          <div  v-if="this.userData.paymethod == 'クレジットカード'">
            <p class="data_contents">{{ splitPaymentText() }}</p>
            <p class="data_contents">
              {{ this.userData.cardNumber }}
              <CreditcardExpired :expired="userData.expired" :expireYearMonth="userData.expireYearMonth" />
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="confirm_coupon bg_white mt12 pt16 pb16 bdb boxs1">
      <h2 class="content_title rb">クーポン</h2>
      <div v-if="userDetailCouponList.length">
        <div v-for="val in userDetailCouponList" class="confirm_wrap pl16 pr25 bdb">
          <p class="confirm_data rb">{{ val.couponName }}</p>
          <p class="coupon_text ab">使用数<span class="count rb">{{ val.useCount }}</span></p>
        </div>
      </div>
      <div v-else class="confirm_wrap pl16 pr25 bdb rb">クーポンは使用していません。</div>
    </div>
    <div class="sum_total bg_white mt12 pt16 pb16">
      <h2 class="content_title sum">合計</h2>
      <AmountList />
    </div>
    <DialogModal
      v-show="isModal"
      :message="modalMessage"
      :modalCheckboxId="modalCheckboxId"
      @modalClose="modalClose"
      @modalCloseTransition="modalCloseTransition"
    />
  </div>
</template>

<script>
import Flow from '@/components/purchase/Flow'
import Config from '@/config/config'
import ConfirmProductsList from '@/components/purchase/ConfirmProductsList';
import AmountList from '@/components/purchase/AmountList';
import { mapGetters } from 'vuex';
import CreditcardExpired from '@/components/common/CreditcardExpired.vue';
import DialogModal from '@/components/common/SwitchDialogModal';

export default {
  props: ['message', 'errorList', 'useBirthMonthDiscount', 'recommendProductMap'],
  components: {
    Flow,
    ConfirmProductsList,
    AmountList,
    CreditcardExpired,
    DialogModal
  },
  data() {
    return {
      userData: {
        shippingTime: '',
        shippingZip: '',
        shippingName: '',
        shippingAddress: '',
        paymethod: '',
        paymentCount: 1,
        cardNumber: '',
        couponList: [],
        couponName: '',
        couponUse: 0,
        expireYearMonth: null,
        expired: false,
        deliveryDate: ''
      },

      shippngCost: 2000,
      otherCost: 500,
      coupon: 0,
      finalPrice: 0,
      isModal: false,
      modalCheckboxId: 'purchaseCompleteModal',
      modalMessage: 'ご注文ありがとうございました。<br>よろしければ、定期購入にしませんか？',
    }
  },
  methods: {
    // クレジットカード払いの時の分割払いテキスト表示用メソッド
    splitPaymentText() {
      return this.userData.paymentCount === 1 ? "一括払い" : `分割払い（${this.userData.paymentCount}回）`
    },
    setUserDetail(shippingTime, zip, addressName, address, paymentName, paymentCount, cardNo, couponList,  expireYearMonth, expired, deliveryDate) {
      this.userData.shippingTime = shippingTime;
      this.userData.shippingZip = zip;
      this.userData.shippingName = addressName;
      this.userData.shippingAddress = address;
      this.userData.paymethod = paymentName;
      this.userData.paymentCount = paymentCount;
      this.userData.cardNumber = cardNo;
      this.userData.expireYearMonth = expireYearMonth;
      this.userData.expired = expired;
      this.userData.deliveryDate = deliveryDate;
      this.userData.couponList.push(...couponList);
       // = couponName;
      // this.userData.couponUse = couponUse;
      if(couponList.length != 0) {
        for (var i = 0; i < couponList.length; i++) {
          this.coupon += couponList[i].discountPrice * couponList[i].useCount;
        }
      }
    },
    createUserDetail () {
      let userDetail = JSON.parse(localStorage.getItem('userDetail'));
      if(userDetail) {
        console.log('use localStorage');
        this.setUserDetail(
          userDetail.deliveryTimeData.deliveryTimeName,
          userDetail.deliveryAddressData.zipCode,
          userDetail.deliveryAddressData.recipientName,
          userDetail.deliveryAddressData.address,
          userDetail.paymentData.paymentMethodName,
          userDetail.paymentData.selectPaymentCount,
          userDetail.selectCreditData.cardNo,
          userDetail.couponList,
          userDetail.selectCreditData.expireYearMonth,
          userDetail.selectCreditData.expired,
          userDetail.deliveryDate.deliveryDateLabel
        );
      }
    },
    strageClear(walletClear) {
      // ストレージの初期化
      localStorage.removeItem('userDetail');
      localStorage.removeItem('nowBC');
      let selectBC = JSON.parse(localStorage.getItem('selectBC'));
      if(selectBC) {
        for (var i = 0; i < selectBC.length; i++) {
          localStorage.removeItem(selectBC[i]);
        }
        localStorage.removeItem('selectBC');
      }
      if(walletClear) {
        this.$store.commit('setPurchaseWalletWalletAmount', 0);
        this.$store.commit('setUserDetailCouponList', []);
        this.$store.commit('setPurchaseWalletUseBirthMonthDiscount', 0);
        this.$store.commit('setPurchaseWalletWalletAmount', 0);
        this.$store.commit('setPurchaseWalletShipmentFee', 0);
        this.$store.commit('setPurchaseWalletUseWalletBillAmount', 0);
        this.$store.commit('setPurchaseWalletselectWalletType', 'NO_USE');
        this.$store.commit('setPurchaseWalletInputWallet', 0);
        this.$store.commit('setPurchaseWalletUseWallet', 0);
        this.$store.commit('setPurchaseWalletUsePurchasePoint', 0);

        this.$store.commit('setUserDetailDeliveryDateLabel', '');
        this.$store.commit('setUserDetailDeliveryDateValue', '');
      }
      this.$store.commit('setUserDetailPaymentDataSelectPaymentCount', 1)
    },
    modalOpen() {
      this.isModal = true;
    },
    modalClose() {
      this.isModal = false;
    },
    async modalCloseTransition() {
      try {
        this.isModal = false;

        // アトミックな状態更新処理
        const updateOperations = [];

        // Vuex更新
        updateOperations.push(
          new Promise((resolve) => {
            this.$store.commit('setRecommendationRecommendProductMap', this.recommendProductMap);
            resolve();
          })
        );

        // localStorage更新
        updateOperations.push(
          new Promise((resolve, reject) => {
            try {
              localStorage.setItem('recommendationRepeatItemList', JSON.stringify(this.recommendProductMap));
              resolve();
            } catch (error) {
              reject(error);
            }
          })
        );

        // すべての更新を並列実行
        await Promise.all(updateOperations);

        // 成功した場合のみ画面遷移
        this.$router.push({ path: '/repeatOrder/multiBc/selectProducts' });

      } catch (error) {
        console.error('状態更新エラー:', error);

        this.$store.commit('setRecommendationRecommendProductMap', {});
      }
    },
    checkRecommendProducts() {
      try {
        // recommendProductMapにデータがあるか確認
        if (!this.recommendProductMap || typeof this.recommendProductMap !== 'object') {
          console.debug('推奨商品マップが無効または空です');
          return false;
        }

        const bcNumbers = Object.keys(this.recommendProductMap);
        if (bcNumbers.length === 0) {
          console.debug('BC番号が見つかりません');
          return false;
        }

        // BCごとにrepeatOrdersListが存在するか確認
        for (const bcNo of bcNumbers) {
          const bcData = this.recommendProductMap[bcNo];

          // bcDataの存在とrepeatOrdersListの検証
          if (bcData &&
              Array.isArray(bcData.repeatOrdersList) &&
              bcData.repeatOrdersList.length > 0) {
            console.debug(`BC ${bcNo}に有効な商品が見つかりました`);
            return true;
          }
        }

        console.debug('任意のBCに有効な商品が見つかりません');
        return false;
      } catch (error) {
        console.error('推奨商品チェックエラー:', error);
        return false;
      }
    },
  },
  computed: mapGetters([
    'purchaseBirthMonthDiscountPrice',
    'purchaseCashOnDeliveryFee',
    'purchaseCouponDiscount',
    'purchaseShipmentFee',
    'purchaseUseBirthMonthDiscount',
    'userDetailCouponList',
    'recommendationPurchaseSettings'
  ]),
  async created () {
    await this.createUserDetail();
    this.strageClear(false);

    // recommendProductMapが存在する場合のみモーダルを表示
    const hasRecommendProducts = this.checkRecommendProducts();

    if (hasRecommendProducts) {
      this.isModal = true;
    } else {
      this.isModal = false;
    }
  },
};
</script>

<style lang="css" scoped>
.complete_text {
  font-size: 18px;
  text-align: center;
}
.error_text {
  color: #ff0000;
  font-size: 16px;
  text-align: center;
}
.errorBc_text {
  margin-top: 5px;
}
.errorBc_list {
  margin-top: 5px;
}

.errorBc_list--item {
  font-size: 17px;
  margin-top: 4px;
}

.complete_btn {
  margin-top: 30px;
}
.content_title {
  width: 140px;
}
.content_title.sum {
  width: 120px;
}



.confirm_wrap {
  align-items: flex-end;
  /* border-bottom: 1px solid #C9C9C9; */
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  padding-bottom: 8px;
}
.edit {
  letter-spacing: 7.5px;
  margin: 0;
  text-indent: 7.5px;
}
.confirm_data {
  color: #5a5a5a;
  font-size: 16px;
  line-height: 1;
}
.data_wrap {
  margin-top: 14px;
}
.data_contents {
  font-size: 14px;
  line-height: 1;
  margin-top: 10px;
}
.coupon_text {
  font-size: 12px;
  line-height: 1;
}
.count {
  font-size: 20px;
  margin-left: 25px;
}
.confirm_coupon .edit {
  margin: 16px 0 0 auto;
}
.confirm_address .confirm_wrap {
  margin-top: 27px;
}
.confirm_credit .confirm_wrap {
  margin-top: 24px;
}
.confirm_coupon .confirm_wrap {
  margin-top: 30px;
}

.sum_total {
  padding-bottom: 48px;
}

.complete {
  margin-top: 56px;
}
</style>



// WEBPACK FOOTER //
// src/views/purchase/Complete.vue